import { Lock, LockOpen } from "lucide-react";

export const PositionLock = ({ locked, value, onToggle, onChange, testid }) => (
  <div className="flex items-center gap-1" data-testid={`poslock-${testid}`}>
    <button type="button" onClick={onToggle} title={locked ? "Posizione manuale (tocca per tornare automatico)" : "Automatico (tocca per modificare la posizione)"}
      className={`p-2 rounded-lg transition-colors ${locked ? "bg-brand text-onbrand" : "bg-surface text-onsurface3"}`}
      data-testid={`poslock-toggle-${testid}`}>
      {locked ? <Lock size={16} /> : <LockOpen size={16} />}
    </button>
    <input type="number" min="1" inputMode="numeric" disabled={!locked} value={value ?? ""} placeholder="pos"
      onChange={(e) => onChange(e.target.value)}
      className={`bg-surface rounded-lg px-2 py-2 font-bold text-onsurface outline-none focus:ring-2 ring-brand text-sm w-12 ${locked ? "" : "opacity-50"}`}
      data-testid={`poslock-input-${testid}`} />
  </div>
);
